import { UPDATE_LOGGED_IN_RECENT_ORDERS_WS, UPDATE_LOGGED_IN_RECENT_ORDERS, UPDATE_TIME_SUMMARY_WS, UPDATE_TIME_SUMMARY } from './chunk-V4FTVBZY.mjs';
import { CLEAR_LOGGED_IN_USER, SET_SETTINGS_ACCESS_LOCATIONS, SET_MENU_ACCESS_LOCATIONS, SET_LOGGED_IN_ROLE_ON_STATE, SET_LOGGED_IN_USER, SET_INITIAL_LOGGED_IN_USER } from './chunk-JGPMBBAW.mjs';
import { USER_INITIAL_STATE, ROLE_INITIAL_STATE } from './chunk-OQ3OIKOT.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/state/loggedInUser/reducers.ts
var USERS_REDUCER_INITIAL_STATE = USER_INITIAL_STATE;
var loggedInUserReducer = (state = USERS_REDUCER_INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SET_INITIAL_LOGGED_IN_USER:
      return __spreadProps(__spreadValues(__spreadValues({}, state), payload), {
        recentOrders: [...payload.recentOrders],
        loggedInRole: ROLE_INITIAL_STATE,
        menuAccessLocations: []
      });
    case SET_LOGGED_IN_USER:
      return __spreadProps(__spreadValues(__spreadValues({}, state), payload), {
        recentOrders: [...payload.recentOrders]
      });
    case SET_LOGGED_IN_ROLE_ON_STATE:
      return __spreadProps(__spreadValues({}, state), {
        loggedInRole: payload
      });
    case SET_MENU_ACCESS_LOCATIONS:
      return __spreadProps(__spreadValues({}, state), {
        menuAccessLocations: payload
      });
    case SET_SETTINGS_ACCESS_LOCATIONS:
      return __spreadProps(__spreadValues({}, state), {
        settingsAccessLocations: payload
      });
    case CLEAR_LOGGED_IN_USER:
      return __spreadValues({}, USER_INITIAL_STATE);
    case UPDATE_TIME_SUMMARY:
    case UPDATE_TIME_SUMMARY_WS: {
      let loggedInUserState = state;
      if (state.organizationUserId === payload.organizationUserId)
        loggedInUserState = __spreadProps(__spreadValues({}, loggedInUserState), {
          shiftTimeSummary: payload
        });
      return __spreadValues({}, loggedInUserState);
    }
    case UPDATE_LOGGED_IN_RECENT_ORDERS:
    case UPDATE_LOGGED_IN_RECENT_ORDERS_WS:
      return __spreadProps(__spreadValues({}, state), {
        recentOrders: payload.recentOrders.map((recentOrder) => __spreadValues({}, recentOrder))
      });
    default:
      return state;
  }
};
var reducers_default = loggedInUserReducer;

export { USERS_REDUCER_INITIAL_STATE, reducers_default };
